import React from 'react'
import { useParams } from '@tanstack/react-router'
import MainLayout from '../../components/layouts/main-layout'
import { convertWpHtmlToJsx } from '../../lib/jsx-converter'
import { getBlogPost } from '../../content/blog-posts'
// Both render in the server HTML, so both are static imports — see
// main-layout.tsx for why lazy() costs a flash of unstyled content here.
import PostMetadata from '../../components/learn/post-meta-data'
import SearchBar from '../../components/layouts/header/header'

const About = () => {
   const { blogSlug } = useParams({ from: '/learn/$blogSlug' })

   const data = getBlogPost(blogSlug)

   if (!data) {
      return (
         <MainLayout>
            <SearchBar />
            <main className="container blog-wrapper text-center my-20">
               <div>Article not found</div>
            </main>
         </MainLayout>
      )
   }

   const content = convertWpHtmlToJsx(data.content)

   return (
      <MainLayout>
         <SearchBar />
         <main className="container blog-wrapper">
            <h1>{data.title}</h1>
            <div className="byline">
               <PostMetadata />
            </div>

            <div className="blog-content">{content}</div>
         </main>
      </MainLayout>
   )
}

export default About
